export default __webpack_public_path__ + "static/media/Meg_Glesener_AHV_In_Moms_We_Trust.e2b931a5.jpg";